
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import GeneralVehicleSelect from "@common/src/components/scope/vehicle-select/index.vue";
import BtnCheck from "@/components/scope/btn-check.vue";
import BtnCheckGroup from "@common/src/components/scope/btn-check-group/index.vue";
import dayjs from "dayjs";
import { mobileRulesEl, partsQuantityRules } from "@common/src/utils/verify";
import t from "@common/src/i18n/t";
import MyCheckbox from "@common/src/components/scope/my-checkbox/index.vue";
import { addCurrencyUnit } from "@common/src/utils/tools";
import RepeatOrderDialog from "@common/src/components/scope/repeat-order-dialog/index.vue";
import TempPurchaseDialog from "@/components/scope/temp-purchase-dialog/index.vue";
import PartsSelector from "@common/src/components/scope/parts-selector/index.vue";

const staff = namespace("staff");
const customer = namespace("customer");
const serviceItem = namespace("service-item");
const service = namespace("service");
const parts = namespace("parts");
const partsCategory = namespace("parts-category");
const user = namespace("user");
const app = namespace("app");
const common_base = namespace("common_base");
const common_app = namespace("common_app");
@Component({
  components: {
    GeneralVehicleSelect,
    BtnCheck,
    BtnCheckGroup,
    MyCheckbox,
    RepeatOrderDialog,
    TempPurchaseDialog,
    PartsSelector
  }
})
export default class ServiceEdit extends Vue {
  @staff.Action getTechnicianStaffList;
  @app.Mutation setPBPX;
  @staff.Action getStaffList;
  @customer.Action getCustomerList;
  @customer.Action getCustomerDetail;
  @serviceItem.Action getServiceDetail;
  @customer.Action saveCustomer;
  @service.Action createRetailOrder;
  @parts.Action getPartsInventoryList;
  @parts.Action getPartsDetail;
  @service.Action getOrderDetail;
  @common_base.State showPlatformParts;
  @service.Action updateOrder;
  @partsCategory.Action getCategoryList;
  @service.Action checkRepeatCreateOrder;
  @parts.Action createParts;
  @user.State userData;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @common_app.State lang;
  @user.State u8cStore;
  dayjs = dayjs;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  get breadData() {
    let typeStr = t("test.new-retail-service");
    return [
      { name: t("test.service-management"), path: "/service/index" },
      { name: this.isAdd ? typeStr : t("service.edit-service-information") }
    ];
  }
  get isAdd() {
    return this.$route.name === "serviceRetailAdd";
  }
  get orderType() {
    return "retail";
  }
  advisorList: any[] = [{}];
  shwoAddServiceModal: boolean = false; // 快捷添加服务modal框显示/隐藏
  shwoQuitConfirm: boolean = false;
  showMobileUsedTips: boolean = false;
  customerList: any[] = [];
  technicianStaffList: any[] = [];
  // 控制form disable状态
  formDisableStatus = {
    customerName: false,
    customerMobile: false
  };
  handleAddParts(tempData?) {
    let technicianArray = [];
    if (
      this.orderFormData?.serviceDetail?.[0]?.technicianCode &&
      this.orderFormData.serviceDetail[0].technicianCode.length > 0
    ) {
      technicianArray = this.orderFormData.serviceDetail[0].technicianCode.slice();
    }
    this.orderFormData.partsDetail.push(
      Object.assign({}, this.definitionPartsData, {
        technicianCode: technicianArray,
        ...(tempData || {})
      })
    );
  }
  selectedCode: string = "";

  searchKey: string = "";
  handleSearchCustomer(val) {
    if (!val) {
      this.customerList = [];
      return;
    }
    this.searchKey = val;
    this.getCustomerList({
      pageSize: 20,
      pageNum: 1,
      searchKey: val
    }).then(data => {
      if (!data.data.list) {
        this.customerList = [];
      } else {
        const customerCodeArr = []; // 去重
        this.customerList = data.data.list.filter(item => {
          if (customerCodeArr.includes(item.customerCode)) {
            return false;
          } else {
            customerCodeArr.push(item.customerCode);
            return true;
          }
        });
      }
    });
  }
  customerDataByMobile: any = {};
  handleQueryCustomerByMobile() {
    if (!this.orderFormData.customerMobile) return;
    this.getCustomerDetail({
      mobile: this.orderFormData.customerMobile
    }).then(data => {
      if (data.data) {
        this.customerDataByMobile = data.data;
        if (!this.orderFormData.customerCode) {
          this.showMobileUsedTips = true;
        }
      } else {
        this.orderFormData.customerCode = "";
      }
    });
  }
  handleSetCustomerInfo() {
    this.orderFormData.customerName = this.customerDataByMobile.customerName;
    this.orderFormData.customerCode = this.customerDataByMobile.customerCode;
    this.showMobileUsedTips = false;
  }
  async handleChooseCustomer(val) {
    if (!val) return;
    await this.setCustomerData(val);
    this.searchKey = "";
    this.selectedCode = val;
  }
  handleSearchBlur() {
    if (this.orderFormData.customerCode) {
      if (this.orderFormData.customerName !== this.searchKey) {
        this.orderFormData.customerName = this.searchKey;
        this.orderFormData.customerCode = "";
      }
    } else {
      this.orderFormData.customerName = this.searchKey;
    }
  }
  emptyToLine = emptyToLine;
  orderFormData: any = {
    externalCustomerFlag: "0",
    orderAmount: "0",
    customerCode: "",
    customerMobile: "",
    customerName: "",
    partsDetail: [],
    storeRemark: "" // 门店备注
  };
  customerFormRules: any = {
    customerName: [{ required: true, message: t("v210831.please-enter-customer"), trigger: "change" }],
    customerMobile: [
      { required: true, message: t("v210831.please-enter-the-customer-mobile"), trigger: "change" },
      { validator: this.validateMobile, trigger: "blur" }
    ]
  };
  validateMobile(rule, value, callback) {
    if (!this.mobileWillCheck) {
      return callback();
    }
    mobileRulesEl(value, callback);
  }
  definitionPartsData: any = {
    partsCode: "",
    partsName: "",
    quantity: "",
    sellingPrice: "",
    amount: "",
    remark: "",
    manual: true,
    technicianCode: [],
    saleCode: ""
  };
  partsList: any[] = [];
  get orderId() {
    return this.$route.params.id;
  }
  created() {
    this.setPBPX(100);
    this.init();
  }
  async init() {
    await this.getTechnicianStaffList({
      // 获取角色为技师的员工
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.technicianStaffList = data.data.list;
    });
    this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
      this.orderFormData.advisorCode = this.userData.userCode;
      this.definitionPartsData.saleCode = this.userData.userCode;
    });
    await this.getPartsLists();
    if (!this.isAdd) {
      this.getOrderDetail({
        orderNo: this.orderId
      }).then(data => {
        data.data.partsDetail.forEach(item => {
          if (item.tempPartsFlag === "1") {
            item.temp = true;
            item.webCreateTempPartsFlag = 1;
            this.tempPartsList.push(parts);
          }
          if (!this.partsList.some(partsItem => partsItem.partsCode === item.partsCode)) {
            this.partsList.push({
              partsCode: item.partsCode,
              partsNameDesc: item.partsNameDesc,
              temp: item.tempPartsFlag === "1"
            });
          }
          item.technicianCodes && (item.technicianCode = item.technicianCodes.split(","));
        });
        this.formDisableStatus.customerName = !!data.data.customerName;
        this.formDisableStatus.customerMobile = !!data.data.customerMobile;
        this.orderFormData = data.data;
        this.orderFormData.customerOilVolume = Number(data.data.customerOilVolume) * 20;
      });
    } else {
      let partsCodes = this.$route.query.partsCodes as any;
      let partsCodeArr = partsCodes ? partsCodes.split(",") : [];
      if (this.queryCustomerCode) {
        this.setCustomerData(this.queryCustomerCode, this.queryVehicleCode);
      }
      partsCodeArr.forEach((item, index) => {
        this.handleAddParts();
        this.handleChooseParts(item, index);
      });
      if (!partsCodeArr.length) {
        this.handleAddParts(); // 默认添加第一行
      }
    }
  }
  handleLinkAddParts() {
    // 当前作业添加弹窗-1223注释
    const { href } = this.$router.resolve("/setting/parts-add");
    window.open(href);
  }
  getPartsLists(name = "") {
    return this.getPartsInventoryList({
      pageNum: 1,
      pageSize: 20,
      searchKey: name,
      notOpadmin: this.showPlatformParts ? "0" : "1"
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []);
    });
  }
  computedAmount(type, index) {
    let amount =
      (this.orderFormData.partsDetail[index].quantity || 0) * this.orderFormData.partsDetail[index].sellingPrice;
    this.orderFormData.partsDetail[index].amount = amount.toFixed(2);
    this.computedTotalAmount();
  }
  computedTotalAmount() {
    const partsTotal = this.orderFormData.partsDetail.reduce((preV, curV) => preV + Number(curV.amount), 0);
    if (Object.is(NaN, partsTotal)) {
      return this.$message.error(t("setting.enter-quantity-or-amount"));
    }
    this.orderFormData.orderAmount = partsTotal.toFixed(2);
  }
  searchParts(val) {
    this.noMatchingPartsName = val;
    this.getPartsLists(val);
  }

  clearParts() {
    // 清除未匹配的套餐零配件
    const selectedServiceGroupIndexArr = this.orderFormData.serviceDetail.map(item => {
      return item.groupServiceIndex;
    });
    for (let partsIndex = 0; partsIndex < this.orderFormData.partsDetail.length; partsIndex++) {
      let currentParts = this.orderFormData.partsDetail[partsIndex];
      // 是套餐中的零配件，并且下标在项目中不存在
      if (currentParts.serviceCode && !selectedServiceGroupIndexArr.includes(currentParts.groupServiceIndex)) {
        this.orderFormData.partsDetail.splice(partsIndex, 1);
        partsIndex--;
      }
    }
  }
  selectParts = {};
  async handleChooseParts(partsCode, index) {
    let partsData = {};
    let partsRowData = this.orderFormData.partsDetail[index];
    const findPardOfList = this.partsList.find(item => item.partsCode === partsCode);
    if (findPardOfList) {
      partsData = Object.assign({}, this.definitionPartsData, findPardOfList, {
        technicianCode: partsRowData?.technicianCode || [],
        temp: !!findPardOfList.temp
      });
    } else {
      await this.getPartsInventoryList({
        partsCodes: [partsCode],
        pageSize: 999,
        partsRuleTypeList: [1, 2, 3]
      }).then(data => {
        partsData = data.data.list?.[0];
        if (partsData) {
          this.partsList.push(partsData);
        } else {
          partsData = Object.assign({}, this.definitionPartsData);
        }
      });
    }
    this.orderFormData.partsDetail.splice(index, 1, partsData);
    this.computedAmount(2, index);
  }
  submitForm(formName) {
    (this.$refs[formName] as any).validate(async valid => {
      if (formName === "customerForm") {
        if (valid && this.checkAddData()) {
          if (this.isAdd) {
            this.checkLastOrderData = await this.beforeSubmitCheck();
            if (!this.checkLastOrderData) {
              this.createService();
            }
          } else {
            this.editService();
          }
        } else {
          console.log("error submit!!");
        }
      }
    });
  }
  checkAddData(): boolean {
    if (this.orderFormData.storeRemark && this.orderFormData.storeRemark.length > 50) {
      this.$message.error(t("v213.store-remarks-can-be-up-to-characters-long"));
      return false;
    }
    if (this.orderType === "retail" && this.orderFormData.partsDetail.length < 1) {
      this.$message.error(t("service.add-least-one-widget"));
      return;
    }
    for (let index = 0; index < this.orderFormData.partsDetail.length; index++) {
      const element = this.orderFormData.partsDetail[index];
      if (!element.partsCode) {
        this.$message.error(t("setting.select-spare-parts"));
        return false;
      }
      if (!element.quantity) {
        this.$message.error(t("service.fill-number-spare-parts"));
        return false;
      }
      const checkPartsQty = partsQuantityRules(element.quantity);
      if (!checkPartsQty.success) {
        this.$message.error(checkPartsQty.msg);
        return false;
      }
      if (!element.isGroupParts && !element.sellingPrice) {
        this.$message.error(t("service.fill-unit-price-spare-parts"));
        return false;
      }
    }
    return true;
  }
  async createService() {
    let saveHasError = false;
    const customerSaveData = {
      customerCode: this.queryCustomerCode || this.orderFormData.customerCode || "",
      vehicle: null,
      customerName: this.orderFormData.customerName,
      mobile: this.orderFormData.customerMobile
    };
    this.btnStartLoading();
    const createResult = await this.saveCustomer(customerSaveData).catch(() => {
      this.btnStopLoading();
      saveHasError = true;
    });
    console.log(t("v210831.save-user-results"), createResult);
    if (saveHasError) {
      return;
    }
    this.btnStartLoading();
    this.orderFormData.customerCode = createResult.data?.customerCode || "";
    this.setTechnicianArray(); // 技师Code format成对象数组

    this.createRetailOrder(this.orderFormData)
      .then(data => {
        this.$message.success(t("base.create-success") as string);
        this.$router.push(`/service/view/${data.data.orderNo}`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  editService() {
    this.btnStartLoading();
    this.setTechnicianArray(); // 技师Code format成对象数组
    this.updateOrder(this.orderFormData)
      .then(() => {
        this.$message.success(t("base.update-success") as string);
        this.$router.push(`/service/view/${this.orderId}`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  setTechnicianArray() {
    this.orderFormData.partsDetail.forEach(serviceItem => {
      serviceItem.technicianArray = (serviceItem?.technicianCode || []).map(item => ({
        technicianCode: item
      }));
      serviceItem.technicianCodes = (serviceItem?.technicianCode || []).join();
    });
  }
  deleteItem(key, index) {
    this.orderFormData[key].splice(index, 1);
  }
  mobileWillCheck = true;
  setCustomerData(customerCode, vehicleCode?) {
    return this.getCustomerDetail({
      customerCode: customerCode,
      vehicleCode: vehicleCode
    }).then(data => {
      const customerData = data.data;
      if (customerData) {
        this.mobileWillCheck = !customerData.mobile;
        this.orderFormData.customerCode = customerData.customerCode;
        this.orderFormData.customerName = customerData.customerName;
        this.orderFormData.customerMobile = customerData.mobile;
      } else {
        this.orderFormData.customerCode = "";
      }
    });
  }
  getIsPushMoney(serviceCode, list) {
    if (serviceCode) {
      let res = list.find(item => serviceCode === item.serviceCode || serviceCode === item.partsCode);

      if (res && res.existCommission === "1") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  handleOpPartsShowChange() {
    this.getPartsLists();
  }
  get queryCustomerCode() {
    return this.$route.query.customerCode;
  }
  get queryVehicleCode() {
    return this.$route.query.vehicleCode;
  }
  checkLastOrderData: any = {};
  beforeSubmitCheck() {
    return this.checkRepeatCreateOrder({
      mobile: this.orderFormData.customerMobile,
      orderType: "3",
      plateCode: null
    }).then(data => {
      return data.data;
    });
  }
  handleConfirmCreateOrder() {
    this.checkLastOrderData = {};
    this.createService();
  }
  noMatchingPartsName: any = "";
  handleLinkQuickAddParts() {
    const href = this.$router.resolve(
      `/setting/parts-add?partsName=${encodeURIComponent(this.noMatchingPartsName)}`
    ).href;
    window.open(href);
  }
  tempPartsList = [];
  handleTempSubmit(data) {
    this.tempPartsList.push(data);
    const pLength = this.orderFormData.partsDetail.length;
    if (this.orderFormData.partsDetail?.[pLength - 1]?.partsCode) {
      this.handleAddParts(data);
    } else {
      this.orderFormData.partsDetail.splice(pLength - 1, 1);
      this.handleAddParts(data);
    }
  }
  handleShowTempPurchase() {
    (this.$refs["tempPurDialog"] as any).open();
  }
}
